// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file unlock_time_limit.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file unlock_time_limit.proto.
 */
export const file_unlock_time_limit: GenFile = /*@__PURE__*/
  fileDesc("Chd1bmxvY2tfdGltZV9saW1pdC5wcm90bxIGZG9tYWluIjMKD1VubG9ja1RpbWVMaW1pdBIPCgdlbmFibGVkGAEgASgIEg8KB21pbnV0ZXMYAiABKA1CMFouZ2l0bGFiLmNvbS9jb3RlY2hkZS9tb25vcmVwby9iYWNrZW5kL2RvbWFpbi9wYmIGcHJvdG8z");

/**
 * @generated from message domain.UnlockTimeLimit
 */
export type UnlockTimeLimit = Message<"domain.UnlockTimeLimit"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: uint32 minutes = 2;
   */
  minutes: number;
};

/**
 * Describes the message domain.UnlockTimeLimit.
 * Use `create(UnlockTimeLimitSchema)` to create a new message.
 */
export const UnlockTimeLimitSchema: GenMessage<UnlockTimeLimit> = /*@__PURE__*/
  messageDesc(file_unlock_time_limit, 0);

